/*
 * クエリのキャッシュ方針
 * staleTime: キャッシュがあるとき取り直すか（取り直す間もキャッシュは返す）
 * gcTime: どこからも使われなくなったキャッシュを残すか
 */

/**
 * 最新: 毎回取り直し、使われなくなっても残す。画面で使うと取り直す間は古いキャッシュを表示する
 * staleTime は 0 でなく 1 秒にする。Suspense で取り終えた直後の購読が stale 扱いで二重取得になるのを避ける（TanStack の Suspense 既定と同じ）
 */
export const LATEST = { staleTime: 1000, gcTime: Infinity } as const;

/** 手動: 自動では取り直さず捨てもしない。更新や破棄は呼び出し側で明示的に行う */
export const MANUAL = { staleTime: Infinity, gcTime: Infinity } as const;

/**
 * 開くたび: 画面を開いている間は取り直さない。
 * キーに画面を開いた時刻を入れ、開くたびに前回のキャッシュを使わず最初から取る画面で使う。
 * 閉じた画面のキャッシュは二度と使われないが、閉じてから gcTime の 5 分が過ぎるまではメモリに残る。
 * gcTime を短くしないのは、Suspense で複数のクエリを待つ間は、先に取り終えたクエリを使う画面がまだ無く、
 * gcTime を過ぎると捨てて取り直してしまうため。5 分は TanStack の既定値
 */
export const PER_OPEN = { staleTime: Infinity, gcTime: 5 * 60 * 1000 } as const;
